<div
    bsModal
    #createOrEditModal="bs-modal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="createOrEditModal"
    aria-hidden="true"
    [config]="{ backdrop: 'static' }"
>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form #departmentForm="ngForm" novalidate (ngSubmit)="save()" autocomplete="off">
                <div class="modal-header">
                    <h4 class="modal-title">
                        <span *ngIf="department.id">{{ l('EditDepartment') }}</span>

                        <span *ngIf="!department.id">{{ l('CreateNewDepartment') }}</span>
                    </h4>

                    <button
                        type="button"
                        class="btn-close"
                        (click)="close()"
                        aria-label="Close"
                        [disabled]="saving"
                    ></button>
                </div>
                <div class="modal-body">
                                        <div class="my-3">
                        <label class="form-label" for="Department_Code">{{ l('Code') }} *</label>
                        <input
                            type="text"
                            #Department_Code="ngModel"
                            id="Department_Code"
                            class="form-control"
                            [(ngModel)]="department.code"
                            name="Code"
                            minlength="0"
                            maxlength="50"
                            required
                        />
                        <validation-messages [formCtrl]="Department_Code"></validation-messages>
                    </div>

                    <div class="my-3">
                        <label class="form-label" for="Department_Name">{{ l('Name') }} *</label>
                        <input
                            type="text"
                            #Department_Name="ngModel"
                            id="Department_Name"
                            class="form-control"
                            [(ngModel)]="department.name"
                            name="Name"
                            minlength="0"
                            maxlength="500"
                            required
                        />
                        <validation-messages [formCtrl]="Department_Name"></validation-messages>
                    </div>
                    <div class="my-3">
                        <label class="form-label" for="ChartOfAccountDisplayProperty">{{ l('PurchaseAccount') }}</label>
                        <select
                            name="department.purchaseAccountId"
                            [(ngModel)]="department.purchaseAccountId"
                            class="form-select"
                        >
                            <option value="">{{ l('SelectAPurchaseAccount') }}</option>

                            <option *ngFor="let item of allChartOfAccounts" value="{{ item.id }}">
                                {{ item.displayName }}
                            </option>
                        </select>
                    </div>

                    <div class="my-3">
                        <label class="form-label" for="ChartOfAccountDisplayProperty2">{{ l('SalesAccount') }}</label>
                        <select
                            name="department.salesAccountId"
                            [(ngModel)]="department.salesAccountId"
                            class="form-select"
                        >
                            <option value="">{{ l('SelectASalesAccount') }}</option>

                            <option *ngFor="let item of allChartOfAccounts" value="{{ item.id }}">
                                {{ item.displayName }}
                            </option>
                        </select>
                    </div>

                    <div class="my-3">
                        <label class="form-label" for="ChartOfAccountDisplayProperty3">{{ l('RebateAccount') }}</label>
                        <select
                            name="department.rebateAccountId"
                            [(ngModel)]="department.rebateAccountId"
                            class="form-select"
                        >
                            <option value="">{{ l('SelectARebateAccount') }}</option>

                            <option *ngFor="let item of allChartOfAccounts" value="{{ item.id }}">
                                {{ item.displayName }}
                            </option>
                        </select>
                    </div>

                    <div class="my-3">
                        <label class="form-label" for="ChartOfAccountDisplayProperty4">{{ l('COGSAccount') }}</label>
                        <select
                            name="department.cogsAccountId"
                            [(ngModel)]="department.cogsAccountId"
                            class="form-select"
                        >
                            <option value="">{{ l('SelectACOGSAccount') }}</option>

                            <option *ngFor="let item of allChartOfAccounts" value="{{ item.id }}">
                                {{ item.displayName }}
                            </option>
                        </select>
                    </div>

                    <div class="my-3">
                        <label class="form-label" for="ChartOfAccountDisplayProperty5">{{ l('AdjustmentAccount') }}</label>
                        <select
                            name="department.adjustmentAccountId"
                            [(ngModel)]="department.adjustmentAccountId"
                            class="form-select"
                        >
                            <option value="">{{ l('SelectAAdjustmentAccount') }}</option>

                            <option *ngFor="let item of allChartOfAccounts" value="{{ item.id }}">
                                {{ item.displayName }}
                            </option>
                        </select>
                    </div>


                </div>
                <div class="modal-footer">
                    <button [disabled]="saving" type="button" class="btn btn-danger" (click)="close()">
                        {{ l('Cancel') }}
                    </button>
                    <button
                        type="submit"
                        class="btn btn-primary blue"
                        [disabled]="!departmentForm.form.valid"
                        [buttonBusy]="saving"
                        [busyText]="l('SavingWithThreeDot')"
                    >
                        <i class="fa fa-save"></i>
                        <span>{{ l('Save') }}</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
